/** Deprecated OpenRouter slugs → current canonical slugs. */
export const OPENROUTER_MODEL_ALIASES: Record<string, string> = {
  "google/gemini-2.5-pro-preview": "google/gemini-2.5-pro",
  "x-ai/grok-4-1": "x-ai/grok-4.1-fast",
  "x-ai/grok-4-1-fast": "x-ai/grok-4.1-fast",
};

export function resolveOpenRouterModelId(id: string): string {
  if (typeof id !== "string") return "";
  const trimmed = id.trim();
  if (!trimmed) return trimmed;
  const base = trimmed.replace(/:online$/i, "");
  const resolved = OPENROUTER_MODEL_ALIASES[base] ?? base;
  return trimmed.endsWith(":online") ? `${resolved}:online` : resolved;
}

/** Models that typically fail when web search tools/plugins are forced on. */
const WEB_SEARCH_BLOCKLIST_PREFIXES = [
  "openai/o1",
  "openai/o3",
  "deepseek/deepseek-r1",
];

export function modelSupportsWebSearch(
  modelId: string,
  supportedParameters?: string[]
): boolean {
  if (typeof modelId !== "string" || !modelId.trim()) return false;
  const base = modelId.replace(/:online$/i, "");
  const blocked = WEB_SEARCH_BLOCKLIST_PREFIXES.some((p) => base.startsWith(p));
  if (blocked) {
    return supportedParameters?.includes("tools") ?? false;
  }
  if (supportedParameters?.length) {
    return supportedParameters.includes("tools");
  }
  return true;
}
